import Focus from '../../../types/enums/focus';
import Pages from '../../../types/enums/pages';
import useKeyboard from './useKeyboard';
import { popRoute } from '../../../store/thunks/route.thunk';
import { pushFocus, setFocus } from '../../../store/slices/focus.slice';
import { store } from '../../../store/store';
import { useRef } from 'react';

function useBackKeyboard({
  blockBack,
  callback,
}: { blockBack?: boolean; callback?: () => void } = {}) {
  const blockBackRef = useRef(blockBack);
  blockBackRef.current = blockBack;
  useKeyboard({
    canBeFocused: false,
    keyDownHandler() {
      return null;
    },
    keyUpHandler(key) {
      if (key === 'BACK') {
        const {
          focus: { focus },
          floatingMenu,
          modal,
          router,
        } = store.getState();

        if (focus === Focus.LOGIN) {
          if (router.route.Page === Pages.SEARCH) {
            store.dispatch(popRoute());
            store.dispatch(setFocus(Focus.MENU));
          } else {
            store.dispatch(setFocus(Focus.MENU));
          }
        } else if (
          focus !== Focus.ADS &&
          focus !== Focus.SPLASH &&
          !floatingMenu.open &&
          !blockBackRef.current &&
          !modal.current
        ) {
          if (callback) {
            callback();
          } else if (focus !== Focus.MENU && !router.route.stack.length) {
            store.dispatch(pushFocus(Focus.MENU));
          } else {
            store.dispatch(popRoute());
          }
        }
      }
    },
  });
}

export default useBackKeyboard;
